<template>
  <c-model
    ref="linkModelContent"
    title="招考环节"
    width="50%"
    @confirm="saveInfo()"
  >
    <el-button
      type="primary"
      size="small"
      @click="addItem"
    >增加招考环节</el-button>

    <el-form
      ref="linkForm"
      :model="dataList"
    >
      <el-table
        :data="dataList.rows"
        class="table-center linkModel"
      >
        <el-table-column
          prop="name"
          label="环节名称"
        >
          <template slot-scope="{row,$index}">
            <el-form-item
              label="环节名称"
              :prop="'rows.'+$index+'.name'"
              hiddenLabel
              hiddenErrorText
              required
            >
              <el-input v-model="row.name"></el-input>
            </el-form-item>
          </template>

        </el-table-column>
        <el-table-column
          prop="startTime"
          label="开始时间"
        >
          <template slot-scope="{row,$index}">
            <el-form-item
              label="开始时间"
              :prop="'rows.'+$index+'.startTime'"
              hiddenLabel
              hiddenErrorText
              required
            >
              <el-date-picker
                v-model="row.startTime"
                type="datetime"
                placeholder="选择开始时间"
              >
              </el-date-picker>
            </el-form-item>

          </template>

        </el-table-column>
        <el-table-column
          prop="endTime"
          label="结束时间"
        >
          <template slot-scope="{row,$index}">
            <el-form-item
              label="结束时间"
              :prop="'rows.'+$index+'.endTime'"
              hiddenLabel
              hiddenErrorText
              required
            >
              <el-date-picker
                v-model="row.endTime"
                type="datetime"
                placeholder="选择结束时间"
              >
              </el-date-picker>
            </el-form-item>

          </template>
        </el-table-column>
        <el-table-column
          label="操作"
          width="80px"
        >
          <template slot-scope="{row,$index}">
            <div class="actions">
              <a @click="deleteItem($index)">删除</a>
            </div>
          </template>

        </el-table-column>
      </el-table>
    </el-form>
  </c-model>
</template>

<script>
import TableMixin from "@/mixins/TableMixin";
export default {
  mixins: [TableMixin],
  props: {
    dataList: {
      default: () => {
        return {
          rows: []
        };
      }
    }
  },
  data() {
    return {
      info: {}
    };
  },
  methods: {
    open() {
      this.openModel("linkModelContent");
    },
    close() {},
    cancel() {
      this.close();
    },
    saveInfo() {
      this.$refs.linkForm.validate(valid => {
        console.log(valid);
        console.log(this.linkData);
        this.$emit("saveLink");
      });
    },
    addItem() {
      this.dataList.rows.push({});
    },
    deleteItem(index) {
      this.dataList.rows.splice(index, 1);
      console.log(index);
    }
  }
};
</script>

<style lang="scss" scoped>
.linkModel {
  .el-date-editor.el-input {
    width: 100%;
  }
}
</style>

